var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "overlay", class: { active: this.$root.menu_active } },
    [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12 pr-0 top-level" }, [
            _vm.menu
              ? _c("nav", { attrs: { id: "main-nav" } }, [
                  _c(
                    "ul",
                    _vm._l(_vm.menu, function (item) {
                      return _c("li", { key: item.ID }, [
                        _c("a", {
                          attrs: { href: item.url },
                          domProps: { innerHTML: _vm._s(item.title) },
                        }),
                      ])
                    }),
                    0
                  ),
                ])
              : _vm._e(),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }